import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

// Define a service using a base URL and expected endpoints
export const trackTypeApi = createApi({
  reducerPath: 'trackTypeApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({    
    trackTypes: builder.query<any, { clientId: string, projectId: string, boreholeId: string, trackCategoryId: string | null }>({
      query: (arg: any) => { 
        const { clientId, projectId, boreholeId, trackCategoryId } = arg;
        return `client/${clientId}/project/${projectId}/borehole/${boreholeId}/trackType?${trackCategoryId ? `trackCategoryId=${trackCategoryId}` : ""}`},
    }),
    trackTypesHierarchy: builder.query<any, { clientId: string, projectId: string, boreholeId: number }>({      
      query: (arg: any) => { 
        const { clientId, projectId, boreholeId } = arg;
        return `client/${clientId}/project/${projectId}/borehole/${boreholeId}/trackType/Hierarchy`},
    }),
    clientTrackTypesHierarchy: builder.query<any, { clientId: string }>({      
      query: (arg: any) => { 
        const { clientId } = arg;
        return `client/${clientId}/TrackType/Hierarchy`},
    }),
    clientImageTypes: builder.query<any, { clientId: string, imageViewer: boolean }>({
      query: (arg: any) => { 
        const { clientId, imageViewer } = arg;
        return `client/${clientId}/ImageTypes/${imageViewer}`},
    }),
    imageTypes: builder.query<any, { clientId: string, projectId: string, boreholeId: string, imageViewer: boolean }>({
      query: (arg: any) => { 
        const { clientId, projectId, boreholeId, imageViewer } = arg;
        return `client/${clientId}/project/${projectId}/borehole/${boreholeId}/imageTypes/${imageViewer}`},
    }),
    trackCategories: builder.query<any, void>({
      query: () => {         
        return `trackCategory`},
    }),
    lithologyTrackTypes: builder.query<any, void>({
      query: (arg: any) => {         
        return `TrackType/Lithology`},
    }),
    textTrackTypes: builder.query<any, void>({
      query: (arg: any) => {         
        return `TrackType/Text`},
    }),
    stratigraphyTrackTypes: builder.query<any, void>({
      query: (arg: any) => {         
        return `TrackType/Stratigraphy`},
    })
  }),  
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useTrackTypesQuery, 
               useImageTypesQuery, 
               useClientImageTypesQuery,
               useTrackCategoriesQuery, 
               useTrackTypesHierarchyQuery,
               useClientTrackTypesHierarchyQuery, 
               useLithologyTrackTypesQuery, 
               useTextTrackTypesQuery,
               useStratigraphyTrackTypesQuery } = trackTypeApi;